import { Permission } from './../../../core/model/permission';
import { MenuItems } from './../../../core/model/menu-items';
import {Component, OnInit} from '@angular/core';
import {PanelMenuModule} from 'primeng/panelmenu'; 
import { Router } from '@angular/router';
import { Module } from 'app/core/model/module';
import { SSL_OP_CISCO_ANYCONNECT } from 'constants';

@Component({ 
  selector: 'sa-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {  
    menu  : MenuItems[] = null; 
    moduleIsNull : boolean ;  
    module : Module ; 
    datai18n : any;
    tituloPantalla : string;
    constructor( protected router: Router) { 
   //console.log("En el constructor de navigation.component");  
  }

  ngOnInit() { 
   //console.log("En el inicio del ngOnInit de navigation.component");
   //console.log(JSON.parse(sessionStorage.getItem('module'))); 
    this.module = JSON.parse(sessionStorage.getItem('module'));
      this.menu=null; 
     //console.log("this.menu : " + this.menu);
      if(this.module==null){
        this.moduleIsNull = true;
        this.datai18n = JSON.parse(localStorage.getItem('datai18n'));
        this.tituloPantalla = this.datai18n['Window.Modules'];
        if(this.tituloPantalla==undefined){
          this.tituloPantalla = "Products";
        }
      }
      else{
        this.moduleIsNull = false;
            while(this.menu == null){
               //console.log("cargando el menu del usuario ... ");
               //console.log(JSON.parse(sessionStorage.getItem('menuSideBar'))); 
                this.menu = JSON.parse(sessionStorage.getItem('menuSideBar'))
               //console.log("this.menu : " + this.menu);
               //console.log(this.menu.length);
            }
           //console.log("Redirigiendo a home del module...");
           //console.log("this.module.moduleHome : "  + this.module.moduleHome);
            this.router.navigate([this.module.moduleHome]);  
           //console.log("En el fin del ngOnInit de navigation.component");
    }
   //console.log("this.menu : ");
   //console.log(this.menu);
    } 
    
    
    getPermission(m : MenuItems){
      let permission : Permission = new Permission();
      let employeeType : number[]=[];
    //console.log(m);
     //console.log(m.permission);
     //console.log(m.permission[0]);
     //console.log(m.permission[0].flg_add);

      permission.windowTitle = m.nameItem;
      permission.flgEmployeeType = m.flgEmployeeType;
      permission.flg_add =m.permission[0].flg_add;
      permission.flg_edit = m.permission[0].flg_edit;
      permission.flg_delete = m.permission[0].flg_delete;
      permission.flg_view = m.permission[0].flg_view;
      permission.flg_calculate = m.permission[0].flg_calculate;
      permission.flg_export = m.permission[0].flg_export;
       
        if(m.flgEmployeeType == true){
          for(var i= 0;i<m.permission.length ; i++){
            employeeType.push(m.permission[i].employee_type_id);
          }
        }
      permission.employeeType = employeeType;
      sessionStorage.setItem('currentPermission', JSON.stringify(permission));
    }
  }
 


// WEBPACK FOOTER //
// ./src/app/shared/layout/navigation/navigation.component.ts